/* eslint-disable indent */
import { Link } from '@solidjs/router';
import { Show, useContext } from 'solid-js';
import { AppContext } from '../../../../app-context-provider/app-context-provider';
import theme from '../../../../style/theme';
import { HeaderNavigationShortcuts } from '../../../header/header-navigation-shortcuts';
import { AtosCareLogo } from '../../../icons-library/atos-care-logo';
import { AtosLogo } from '../../../icons-library/atos-logo-desktop';
import { CrossIcon } from '../../../icons-library/cross';
import { StyledSpacer } from '../../../login-menu/login-menu.styles';
import type { MenuHeaderMobileProps, MenuHeaderProps } from '../../menu-header-types';
import {
    StyledCrossButton,
    StyledMenuHeader,
    StyledMenuHeaderIconLinks,
    StyledMenuHeaderTop,
} from './menu-header.styles';

export const MenuHeader = (props: MenuHeaderProps & MenuHeaderMobileProps) => {
    const { viewport, siteInfo } = useContext(AppContext);

    return (
        <StyledMenuHeader>
            <StyledMenuHeaderTop>
                <Link
                    href="/"
                    onClick={() => props.handleCloseMenuClick()}
                    ref={(el: HTMLElement) => {
                        if (props.firstElement) {
                            props.firstElement(el);
                        }
                    }}
                >
                    <Show when={siteInfo.siteType === 'default'} fallback={<AtosCareLogo width={8} height={4.34} />}>
                        <AtosLogo width={9.36} />
                    </Show>
                </Link>
                <StyledMenuHeaderIconLinks>
                    <HeaderNavigationShortcuts />
                    <StyledSpacer />
                    <StyledCrossButton onClick={() => props.handleCloseMenuClick()}>
                        <CrossIcon
                            {...(viewport.width < theme.breakpoints.MOBILE
                                ? {
                                    height: 2.3,
                                    width: 2.3,
                                    opacity: 0.7,
                                }
                                : { height: 1.9, width: 1.9 })}
                        />
                    </StyledCrossButton>
                </StyledMenuHeaderIconLinks>
            </StyledMenuHeaderTop>

        </StyledMenuHeader>
    );
};
